module.exports = __webpack_public_path__ + "img/card_membership.ca9a02c2.svg";